var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClosed()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v("\n          Equipos Finalizados\n        ")
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "" } },
                                          [
                                            _c(
                                              "v-container",
                                              { attrs: { "grid-list-md": "" } },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticClass: "h2_title mb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Información de Equipos\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c("v-divider"),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      xs12: "",
                                                      sm12: "",
                                                      md12: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs12: "",
                                                          sm6: "",
                                                          md6: "",
                                                          lg4: "",
                                                          "mt-4": "",
                                                          "mb-5": ""
                                                        }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: "Buscar...",
                                                            "append-icon":
                                                              "search"
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.handleSearch
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.quickSearch,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.quickSearch = $$v
                                                            },
                                                            expression:
                                                              "quickSearch"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          sm12: "",
                                                          md12: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-card",
                                                          {
                                                            staticClass:
                                                              "rounded-card"
                                                          },
                                                          [
                                                            _c(
                                                              "GridComponent",
                                                              {
                                                                staticClass:
                                                                  "ag-theme-material",
                                                                attrs: {
                                                                  "grid-options":
                                                                    _vm.gridOptions
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }